export default "__VITE_ASSET__CB3H2TZK__"